import { render, staticRenderFns } from "./feature-card-tech.vue?vue&type=template&id=bbcead9c&scoped=true&"
import script from "./feature-card-tech.vue?vue&type=script&lang=js&"
export * from "./feature-card-tech.vue?vue&type=script&lang=js&"
import style0 from "./feature-card-tech.vue?vue&type=style&index=0&id=bbcead9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcead9c",
  null
  
)

export default component.exports